{
  "blocks": [
    {
      "id": "module-female-optimization",
      "kind": "module",
      "tags": ["her", "optimization", "pre-cycle", "supplements", "lifestyle"],
      "title": "Egg Quality Optimization",
      "subtitle": "90-day protocol to support your maturing eggs",
      "icon": "🌱",
      "body": {
        "duration": "90 days",
        "category": "optimization",
        "forWhom": "her",
        "includes": [
          "Targeted supplement protocol (CoQ10 400–600mg, Vitamin D, Omega-3, Methylfolate)",
          "DHEA assessment for diminished ovarian reserve",
          "Lifestyle guidance (sleep, exercise, stress management)",
          "Monthly check-in questionnaires",
          "Day-3 labs at 90 days to track trends"
        ],
        "trackableMarkers": [
          {
            "name": "Vitamin D",
            "expectedToChange": true,
            "expectation": "Correctable with supplementation. Retest at 8 weeks to confirm adequate levels (>40 ng/mL).",
            "retestInterval": "8 weeks"
          },
          {
            "name": "TSH",
            "expectedToChange": true,
            "expectation": "If elevated, medication can normalize TSH. Goal is <2.5 for fertility.",
            "retestInterval": "6–8 weeks after starting medication"
          },
          {
            "name": "AMH",
            "expectedToChange": false,
            "expectation": "AMH reflects your follicle pool and generally only declines with age. We track it to understand your trajectory, not to measure improvement.",
            "retestInterval": "6 months"
          }
        ],
        "priceRange": {
          "low": 200,
          "high": 500
        },
        "currency": "USD",
        "status": "coming-soon",
        "steps": [
          {
            "title": "Start supplements",
            "description": "Begin CoQ10, Vitamin D, Omega-3, and methylfolate. These take ~3 months to affect maturing eggs."
          },
          {
            "title": "Lifestyle adjustments",
            "description": "Sleep 7–9 hours, moderate exercise, manage stress. These affect the hormonal environment your eggs develop in."
          },
          {
            "title": "Monthly check-in",
            "description": "Quick questionnaire about energy, sleep, and side effects. Protocol adjusted if needed."
          },
          {
            "title": "90-day retest",
            "description": "Repeat hormone panel. Vitamin D and thyroid should be optimized. AMH tracked for trend awareness."
          }
        ]
      },
      "sources": [
        {
          "title": "Coenzyme Q10 supplementation and oocyte quality",
          "journal": "Reproductive BioMedicine Online",
          "year": 2021,
          "evidenceLevel": "rct"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
